import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetArchargesForInvoiceQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['bigint']['input'];
}>;


export type GetArchargesForInvoiceQuery = { __typename?: 'query_root', archarges: Array<{ __typename?: 'archarges', id: number }> };


export const GetArchargesForInvoiceDocument = gql`
    query GetArchargesForInvoice($invoiceId: bigint!) {
  archarges(
    where: {active: {_eq: true}, argroup: {arinvoice_id: {_eq: $invoiceId}, status: {_eq: "done"}}, type: {_neq: "processing_fee"}}
    order_by: [{createdat: asc}]
  ) {
    id
  }
}
    `;

/**
 * __useGetArchargesForInvoiceQuery__
 *
 * To run a query within a React component, call `useGetArchargesForInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchargesForInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchargesForInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetArchargesForInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables> & ({ variables: GetArchargesForInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>(GetArchargesForInvoiceDocument, options);
      }
export function useGetArchargesForInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>(GetArchargesForInvoiceDocument, options);
        }
// @ts-ignore
export function useGetArchargesForInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>;
export function useGetArchargesForInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<GetArchargesForInvoiceQuery | undefined, GetArchargesForInvoiceQueryVariables>;
export function useGetArchargesForInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>(GetArchargesForInvoiceDocument, options);
        }
export type GetArchargesForInvoiceQueryHookResult = ReturnType<typeof useGetArchargesForInvoiceQuery>;
export type GetArchargesForInvoiceLazyQueryHookResult = ReturnType<typeof useGetArchargesForInvoiceLazyQuery>;
export type GetArchargesForInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetArchargesForInvoiceSuspenseQuery>;
export type GetArchargesForInvoiceQueryResult = Apollo.QueryResult<GetArchargesForInvoiceQuery, GetArchargesForInvoiceQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/invoices/queries/getArchargesForInvoice.query.gql}
 */
export async function getArchargesForInvoice(
  variables: GetArchargesForInvoiceQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetArchargesForInvoiceQuery['archarges']>
export async function getArchargesForInvoice(
  variables: GetArchargesForInvoiceQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetArchargesForInvoiceQuery>
export async function getArchargesForInvoice(
  variables: GetArchargesForInvoiceQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetArchargesForInvoiceQuery['archarges'] | GetArchargesForInvoiceQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetArchargesForInvoiceQuery>(
    GetArchargesForInvoiceDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.archarges
}